const SUBDIRECTORY = process.env.VUE_APP_API_SUBDIRECTORY === undefined ? '' : process.env.VUE_APP_API_SUBDIRECTORY;

const Config = {
  HOST: {
    PATH: process.env.VUE_APP_API_HOST,
    SUBDIRECTORY: SUBDIRECTORY,
    URL: process.env.VUE_APP_API_HOST + SUBDIRECTORY,
  },
  PARKKI_APP: {
    ID: process.env.VUE_APP_PARKKI_APP_ID,
    KEY: process.env.VUE_APP_PARKKI_APP_KEY,
    VERSION: process.env.VUE_APP_PARKKI_APP_VERSION,
  },
  FRONT: {
    PATH: process.env.VUE_APP_HOST_APP_PARKKI_APP,
  },
  MAPBOX: {
    TOKEN: process.env.VUE_APP_MAPBOX_TOKEN,
    MIN_ZOOM: 13,
    MAX_ZOOM: 18,
  },
  API_ROUTES: {
    LOGIN: '/auth/app',
    REQUEST_TOKENS: '/auth/request_access_token',
    APP_SETTINGS: '/apps/settings',
    CONTRACTS: {
      GET_ALL: '/apps/contracts',
    },
    SITES: {
      GET_ALL: '/apps/sites',
      GET_ONE: '/apps/sites/:site_id',
      GET_PARKINGS: '/apps/sites/:site_id/parkings',
      GET_DESTINATIONS: '/apps/sites/:site_id/destinations',
    },
    PARKINGS: {
      GET_ALL: '/apps/parkings',
    },
    NAVIGATION: {
      GET_SITES: '/apps/companies/navigation/sites',
      GET_PARKINGS: '/apps/companies/navigation/parkings',
      GET_BEST_SPOT: '/apps/companies/navigation/spot',
      GET_BEST_AREA: '/apps/companies/navigation/area',
    },
  },
  SHOW_HEADER_SITES_LIST: false,
  COLORS: {
    ORANGE: '#2296a4',
    GRAY: 'gray',
    BLACK: '#616161',
  },
  ATTENDANCE: {
    RED: {
      VALUE: 70,
      COLOR: '#ff616e',
    },
    ORANGE: {
      VALUE: 50,
      COLOR: '#e8d95a',
    },
    GREEN: {
      VALUE: 0,
      COLOR: 'rgba(76,175,81,1)',
    },
  },
  ATTENDANCE_DEFAULT_LABELS: ['00h', '01h', '02h', '03h', '04h', '05h', '06h', '07h', '08h', '09h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h'],
  ATTENDANCE_SMOOTH_COEF: 3,
  ATTENDANCE_BAR: {
    RED: {
      VALUE: 99,
      COLOR: '#d8554c',
    },
    ORANGE: {
      VALUE: 81,
      COLOR: 'orange',
    },
    YELLOW: {
      VALUE: 51,
      COLOR: '#e8d95a',
    },
    GREEN: {
      VALUE: 0,
      COLOR: '#4caf51',
    },
  },
  SCORE: {
    RED: {
      VALUE: 0,
      COLOR: '#d8554c',
    },
    ORANGE: {
      VALUE: 0.3,
      COLOR: 'orange',
    },
    GREEN: {
      VALUE: 0.6,
      COLOR: '#4caf51',
    },
  },
};

export { Config };
